import React from 'react';
import ReactECharts from 'echarts-for-react';
import {
  PARTNER_BLUE_COLORS,
  buildChartTheme,
  truncateChartLabel,
} from './chartTheme';
import useLaptopCompact from './useLaptopCompact';
import ChartEmptyState from './ChartEmptyState';

const partnerSplitLine = {
  lineStyle: { type: 'dashed', color: 'rgba(148, 163, 184, 0.32)', width: 1 },
};

const SimpleVerticalBarChart = ({
  data,
  yAxisLabel = 'Bookings',
  renderZeroWhenEmpty = false,
  emptyStateTitle = 'No activity for this period',
  emptyStateSubtitle = 'Try changing the time filter.',
  emptyStateCompact = false,
}) => {
  const isLaptopCompact = useLaptopCompact();
  const theme = buildChartTheme(isLaptopCompact);

  const hasData = Array.isArray(data) && data.length > 0;
  if (!hasData && !renderZeroWhenEmpty) {
    return (
      <ChartEmptyState
        title={emptyStateTitle}
        subtitle={emptyStateSubtitle}
        compact={emptyStateCompact}
      />
    );
  }
  const normalizedData = hasData ? data : [{ name: '', value: 0 }];

  const options = {
    animation: false,
    grid: theme.gridStandard,
    tooltip: {
      ...theme.tooltipBase,
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params) => {
        const row = params?.[0];
        return `${row?.axisValue || ''}<br/>${yAxisLabel}: ${row?.value ?? 0}`;
      },
    },
    xAxis: {
      type: 'category',
      data: normalizedData.map((d) => d.name),
      axisLabel: {
        ...theme.axisLabel,
        rotate: normalizedData.length > 5 ? 16 : 0,
        formatter: (value) => truncateChartLabel(value, 15),
      },
    },
    yAxis: {
      type: 'value',
      name: yAxisLabel,
      nameTextStyle: theme.axisNameStyle,
      axisLabel: theme.axisLabel,
      min: 0,
      minInterval: 1,
      splitLine: partnerSplitLine,
    },
    series: [{
      type: 'bar',
      barMaxWidth: 40,
      data: normalizedData.map((d, idx) => ({
        value: d.value,
        itemStyle: { color: PARTNER_BLUE_COLORS[idx % PARTNER_BLUE_COLORS.length] },
      })),
      label: {
        show: true,
        position: 'top',
        fontSize: theme.fs(12),
        color: '#374151',
        fontWeight: 600,
      },
    }],
  };

  return (
    <ReactECharts
      option={options}
      style={{ height: `${isLaptopCompact ? 300 : 320}px`, width: '100%' }}
      opts={{ renderer: 'canvas' }}
    />
  );
};

export default SimpleVerticalBarChart;
